// extracted by mini-css-extract-plugin
export default {"base":"SelectInputFilter_base__BKa3t"};